var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8281 0.21875C11.1836 0.410156 11.375 0.765625 11.375 1.14844V11.2109C11.375 11.5938 11.1836 11.9492 10.8281 12.1406C10.5 12.3594 10.0898 12.3594 9.76172 12.168L0.574219 7.13672C0.21875 6.94531 0 6.58984 0 6.17969C0 5.76953 0.21875 5.41406 0.574219 5.22266L9.76172 0.191406C10.0898 0 10.5 0 10.8281 0.21875ZM10.0625 1.53125L1.55859 6.17969L10.0625 10.8555V1.53125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay2);
export default __webpack_public_path__ + "static/media/Play2.77f4f4f3124337dc99e40ca332d92d01.svg";
export { ForwardRef as ReactComponent };